import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import {
    fetchClaimCategoriesByPolicyTypeFailedAction,
    fetchClaimCategoriesByPolicyTypeSuccessAction,
} from '../actions/claimCategory';
type State = {
    claimCategory:
        | {
              byId: { [id: string]: any };
              allIds: Array<string> | [];
          }
        | any;
    loading: boolean;
    errorMessage: null | Array<string> | any;
};
const INITIAL_STATE: State = {
    claimCategory: {
        byId: {},
        allIds: [],
    },
    loading: false,
    errorMessage: null,
};

const fetchClaimCategories = (state: State): State => {
    return state;
};

const fetchClaimCategoriesSuccess = (state: State): State => {
    return state;
};

const fetchClaimCategoriesFailed = (state: State): State => {
    return state;
};

const fetchClaimCategoriesByPolicyType = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchClaimCategoriesByPolicyTypeSuccess = (
    state: State,
    action: PayloadAction<fetchClaimCategoriesByPolicyTypeSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'id',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        claimCategory: {
            ...state.claimCategory,
            byId: byId,
            allIds: allIds,
        },
    };
};

const fetchClaimCategoriesByPolicyTypeFailed = (
    state: State,
    action: PayloadAction<fetchClaimCategoriesByPolicyTypeFailedAction>,
): State => {
    return {
        ...state,
        errorMessage: action.payload.body,
        loading: false,
    };
};
const clearClaimCategory = (): State => {
    return {
        ...INITIAL_STATE,
    };
};

const claimCategory = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_CLAIM_CATEGORIES]: fetchClaimCategories,
    [ActionTypes.FETCH_CLAIM_CATEGORIES_SUCCESS]: fetchClaimCategoriesSuccess,
    [ActionTypes.FETCH_CLAIM_CATEGORIES_FAILED]: fetchClaimCategoriesFailed,
    [ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE]:
        fetchClaimCategoriesByPolicyType,
    [ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_SUCCESS]:
        fetchClaimCategoriesByPolicyTypeSuccess,
    [ActionTypes.FETCH_CLAIM_CATEGORIES_BY_POLICY_TYPE_FAILED]:
        fetchClaimCategoriesByPolicyTypeFailed,
    [ActionTypes.CLEAR_CLAIM_CATEGORY_STATE]: clearClaimCategory,
    [ActionTypes.REDIRECT_AFTER_CLAIM_SUBMIT]: clearClaimCategory,
});

export default claimCategory;
